import api from "./api";

const unwrap = (response) => response.data?.data ?? response.data;

export const loginUser = async (credentials) => unwrap(await api.post("/auth/login/web", credentials)); 
export const changePassword = async (payload) => unwrap(await api.patch("/auth/password", payload));

export const getDashboardSummary = async (params = {}) => unwrap(await api.get("/dashboard/summary", { params }));

export const fetchClients = async (params = {}) => unwrap(await api.get("/clients", { params }));
export const fetchClientFiche = async (id) => unwrap(await api.get(`/clients/${id}/fiche`));
export const createClient = async (payload) => unwrap(await api.post("/clients", payload));
export const updateClient = async (id, payload) => unwrap(await api.put(`/clients/${id}`, payload));
export const deleteClient = async (id) => unwrap(await api.delete(`/clients/${id}`));
export const fetchActivityCatalog = async () => unwrap(await api.get("/clients/activities"));
export const createActivityCatalog = async (payload) => unwrap(await api.post("/clients/activities", payload));

export const fetchProducts = async (params = {}) => unwrap(await api.get("/products", { params }));
export const createProduct = async (payload) => unwrap(await api.post("/products", payload));
export const updateProduct = async (id, payload) => unwrap(await api.put(`/products/${id}`, payload));
export const deleteProduct = async (id) => unwrap(await api.delete(`/products/${id}`));

export const fetchInvestments = async (params = {}) => unwrap(await api.get("/investments", { params }));
export const createInvestment = async (payload) => unwrap(await api.post("/investments", payload));
export const updateInvestment = async (id, payload) => unwrap(await api.put(`/investments/${id}`, payload));
export const updateInvestmentStatus = async (id, payload) => unwrap(await api.patch(`/investments/${id}/status`, payload));
export const assignRecoveryAgent = async (id, payload) => unwrap(await api.patch(`/investments/${id}/assign`, payload));
export const disburseInvestment = async (id, payload) => unwrap(await api.post(`/investments/${id}/disburse`, payload));
export const closeInvestment = async (id, payload) => unwrap(await api.patch(`/investments/${id}/close`, payload));
export const fetchInvestmentSchedule = async (id) => unwrap(await api.get(`/investments/${id}/schedule`));

export const fetchRecoveries = async (params = {}) => unwrap(await api.get("/recoveries", { params }));
export const createRecovery = async (payload) => unwrap(await api.post("/recoveries", payload));
export const requestRecoveryCorrection = async (id, payload) => unwrap(await api.post(`/recoveries/${id}/corrections`, payload));
export const fetchDailyClosures = async (params = {}) => unwrap(await api.get("/daily-closures", { params }));
export const fetchDailyClosureDetails = async (id) => unwrap(await api.get(`/daily-closures/${id}/details`));
export const createDailyClosure = async (payload) => unwrap(await api.post("/daily-closures", payload));
export const validateDailyClosure = async (id, payload) => unwrap(await api.patch(`/daily-closures/${id}/validate`, payload));

export const fetchIncidents = async (params = {}) => unwrap(await api.get("/incidents", { params }));
export const detectIncidents = async () => unwrap(await api.post("/incidents/detect"));
export const resolveIncident = async (id, payload) => unwrap(await api.patch(`/incidents/${id}/resolve`, payload));

export const fetchAccounts = async () => unwrap(await api.get("/treasury/accounts"));
export const createAccount = async (payload) => unwrap(await api.post("/treasury/accounts", payload));
export const fetchTransactions = async () => unwrap(await api.get("/treasury/transactions"));
export const createTransaction = async (payload) => unwrap(await api.post("/treasury/transactions", payload));

export const fetchInvestors = async () => unwrap(await api.get("/funds/investors"));
export const createInvestor = async (payload) => unwrap(await api.post("/funds/investors", payload));
export const updateInvestor = async (id, payload) => unwrap(await api.put(`/funds/investors/${id}`, payload));
export const deleteInvestor = async (id) => unwrap(await api.delete(`/funds/investors/${id}`));
export const fetchFunds = async () => unwrap(await api.get("/funds"));
export const createFund = async (payload) => unwrap(await api.post("/funds", payload));
export const createFundMovement = async (payload) => unwrap(await api.post("/funds/movements", payload));

export const fetchDailyReport = async (params = {}) => unwrap(await api.get("/reports/daily", { params }));
export const fetchWeeklyReport = async (params = {}) => unwrap(await api.get("/reports/weekly", { params }));
export const fetchMonthlyReport = async (params = {}) => unwrap(await api.get("/reports/monthly", { params }));
export const fetchManagementReport = async (params = {}) => unwrap(await api.get("/reports/management", { params }));
export const fetchManagementReportDetails = async (params = {}) => unwrap(await api.get("/reports/management/details", { params }));

export const fetchAuditLogs = async (params = {}) => unwrap(await api.get("/audit", { params }));

export const fetchUsers = async () => unwrap(await api.get("/users"));
export const fetchRoles = async () => unwrap(await api.get("/users/roles"));
export const createUser = async (payload) => unwrap(await api.post("/users", payload));
export const updateUser = async (id, payload) => unwrap(await api.put(`/users/${id}`, payload));
export const deleteUser = async (id) => unwrap(await api.delete(`/users/${id}`));
export const fetchAgencies = async () => unwrap(await api.get("/agencies"));

export const fetchNotifications = async (params = {}) => unwrap(await api.get("/notifications", { params }));
export const fetchUnreadNotificationsCount = async () => unwrap(await api.get("/notifications/unread-count"));
export const markNotificationRead = async (id) => unwrap(await api.patch(`/notifications/${id}/read`));
export const markAllNotificationsRead = async () => unwrap(await api.patch("/notifications/read-all"));
